var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "overflow-y-auto",
      style: { height: "calc(100vh - 4.5rem - 8rem - 3.5rem)" }
    },
    [
      _vm.fetchLoading
        ? _c(
            "div",
            { staticClass: "h-full grid items-center justify-center" },
            [_c("div", { staticClass: "blum-loader" })]
          )
        : !_vm.prospectActivityHistories.length
        ? _c(
            "div",
            { staticClass: "h-full grid items-center justify-center" },
            [
              _c("BlTextBody2", {
                attrs: {
                  text: "There are no activiry histories for this prospect."
                }
              })
            ],
            1
          )
        : _c(
            "div",
            { staticClass: "py-4 px-6" },
            _vm._l(_vm.prospectActivityHistories, function(activity, idx) {
              return _c("BlActivity", {
                key: activity.id,
                attrs: {
                  activity: activity,
                  isFirst: idx === 0,
                  isLast: idx + 1 === _vm.prospectActivityHistories.length
                }
              })
            }),
            1
          )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-51a9b3cc", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-51a9b3cc","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/salesPipeline/modal/prospectPanel/ActivityHistoryTab.vue
// module id = null
// module chunks = 